dometic = {};
dometic.dealerLocator2 = {};
dometic.dealerLocator2.search = {
  init: function init() {
    this.searchButton.init();
    this.redoSearchButton.bindEvents();
    this.autocomplete.init();
    this.useMyLocation.getMyPositionOnPageLoad();
    this.filters.init();
    this.handleFilterContextInQueryString();
    this.handleInitialMapSettings();
  },
  context: {
    maxResults: 500,
    distance: 20,
    location: {
      lat: "",
      lng: ""
    },
    partnerType: "",
    stationary: null,
    onroad: null,
    //applications: [],
    //businessSolutions: [],
    productCategories: [],
    groups: [],
    //serviceCenterCategories: [],
    productType: []
  },
  constants: {
    startDistance: 20,
    startMaxResults: 500
  },
  searchButton: {
    constants: {
      searchButtonIDselector: "#dealerLocatorSearchComponent-btnSubmit",
      searchButtonLoadingClass: "is-loading",
      searchTextBoxIDSelector: "#dealerLocatorSearchComponent-input"
    },
    bindEvents: function bindEvents() {
      $(this.constants.searchButtonIDselector).click(this.searchButtonClick);
    },
    searchButtonClick: function searchButtonClick(e) {
      e.preventDefault();

      //Note that "True" is case sensitive and needs to have a capital letter at the starts
      var skipValidation = $(".dealerLocatorHeroComponent").find("[data-validation='True']");
      var dataString = $('.dealerLocatorHeroComponent').find("[data-groups]").data().groups;
      var dataArray = dataString.split('|');
      if (dataArray.length > 0) {
        dometic.dealerLocator2.search.context.groups = dataArray;
      } else {
        dometic.dealerLocator2.search.context.groups = dataString;
      }
      if (skipValidation.length > 0) {
        //skips the validation!
      } else {
        if (dometic.dealerLocator2.search.context.productCategories.length <= 0 || dometic.dealerLocator2.search.context.productType.length <= 0 || dometic.dealerLocator2.search.context.location.lat.length === 0 || dometic.dealerLocator2.search.context.location.lng.length === 0 || $("#dealerLocatorSearchComponent-input").val().trim() === "") {
          if (dometic.dealerLocator2.search.context.location.lat.length === 0 || dometic.dealerLocator2.search.context.location.lng.length === 0 || $("#dealerLocatorSearchComponent-input").val().trim() === "") {
            $(dometic.dealerLocator2.search.searchButton.constants.searchTextBoxIDSelector).addClass("is-flashing");
            setTimeout(function () {
              $(dometic.dealerLocator2.search.searchButton.constants.searchTextBoxIDSelector).removeClass("is-flashing");
            }, 1000);

            //This isn't working, no such property exist in useMyLocation.
            /* $(dometic.dealerLocator2.search.useMyLocation.constants.useMyLocationLinkIdSelector).hide(); */
          }
          if (dometic.dealerLocator2.search.context.productCategories.length <= 0) {
            $(".dealerLocatorFilterComponent").find("[data-id='productCategory-dropdown']").addClass("is-flashing");
            setTimeout(function () {
              $(".dealerLocatorFilterComponent").find("[data-id='productCategory-dropdown']").removeClass("is-flashing");
            }, 1000);
          }
          if (dometic.dealerLocator2.search.context.productType.length <= 0) {
            $(".dealerLocatorFilterComponent").find("[data-id='productType-dropdown']").addClass("is-flashing");
            setTimeout(function () {
              $(".dealerLocatorFilterComponent").find("[data-id='productType-dropdown']").removeClass("is-flashing");
            }, 1000);
          }
          return;
        }
      }
      dometic.dealerLocator2.search.context.distance = dometic.dealerLocator2.search.constants.startDistance;
      dometic.dealerLocator2.search.context.maxResults = dometic.dealerLocator2.search.constants.startMaxResults;
      if (typeof dometic.dealerLocator2.mapView != 'undefined') {
        dometic.dealerLocator2.mapView.current.zoom = 12;
      }
      dometic.dealerLocator2.search.doSearch();
    },
    addLoadingClass: function addLoadingClass() {
      $(dometic.dealerLocator2.search.searchButton.constants.searchButtonIDselector).addClass("is-loading");
    },
    removeLoadingClass: function removeLoadingClass() {
      $(dometic.dealerLocator2.search.searchButton.constants.searchButtonIDselector).removeClass("is-loading");
    },
    init: function init() {
      this.bindEvents();
    }
  },
  autocomplete: {
    constants: {
      searchTextBoxIDSelector: "#dealerLocatorSearchComponent-input"
    },
    googleMapsAutocomplete: null,
    setupGoogleAutoComplete: function setupGoogleAutoComplete() {
      var autocompleteType = $("#dealerLocatorSearchComponent-input").data("autocomplete-type");
      if (typeof autocompleteType !== 'undefined' && autocompleteType != null && autocompleteType.length > 0) {
        this.googleMapsAutocomplete = new google.maps.places.Autocomplete(document.getElementById("dealerLocatorSearchComponent-input"), {
          types: [autocompleteType],
          fields: ["name", "geometry.location", "place_id", "formatted_address"]
        });
      } else {
        this.googleMapsAutocomplete = new google.maps.places.Autocomplete(document.getElementById("dealerLocatorSearchComponent-input"), {
          fields: ["name", "geometry.location", "place_id", "formatted_address"]
        });
      }
      this.googleMapsAutocomplete.types = [autocompleteType];
      this.setAutocompleteBiasedToCountry();
    },
    setAutocompleteBiasedToCountry: function setAutocompleteBiasedToCountry() {
      var url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + $("body").data("sc-market") + "&key=" + $(".dealerLocatorSearchComponent").data("apikey");
      $.get(url, function (response) {
        if (response.results.length === 0) {
          console.log(response);
          return;
        }
        var lat = response.results[0].geometry.location.lat;
        var lng = response.results[0].geometry.location.lng;
        dometic.dealerLocator2.search.autocomplete.googleMapsAutocomplete.setBounds(new google.maps.LatLngBounds({
          lat: lat,
          lng: lng
        }));
      });
    },
    bindEvents: function bindEvents() {
      this.googleMapsAutocomplete.addListener('place_changed', this.autocompletePlaceChanged);
    },
    autocompletePlaceChanged: function autocompletePlaceChanged() {
      var place = dometic.dealerLocator2.search.autocomplete.googleMapsAutocomplete.getPlace();
      if (!place.geometry) {
        var textboxValue = $(dometic.dealerLocator2.search.autocomplete.constants.searchTextBoxIDSelector).val();
        if (textboxValue.length === 0) return;
        dometic.dealerLocator2.search.autocomplete.getFirstPlaceInAutoComplete(textboxValue, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) return;
          place = results[0];
          dometic.dealerLocator2.search.context.location.lat = place.geometry.location.lat();
          dometic.dealerLocator2.search.context.location.lng = place.geometry.location.lng();
          $(dometic.dealerLocator2.search.autocomplete.constants.searchTextBoxIDSelector).val(place.formatted_address);
          dometic.dealerLocator2.search.doSearch();
        });
      } else {
        dometic.dealerLocator2.search.context.location.lat = place.geometry.location.lat();
        dometic.dealerLocator2.search.context.location.lng = place.geometry.location.lng();
        $(dometic.dealerLocator2.search.autocomplete.constants.searchTextBoxIDSelector).val(place.formatted_address);
      }
    },
    getFirstPlaceInAutoComplete: function getFirstPlaceInAutoComplete(textboxValue, callback) {
      var service = new google.maps.places.AutocompleteService();
      service.getPlacePredictions({
        input: textboxValue,
        componentRestrictions: {}
      }, function (results, status) {
        if (status !== google.maps.places.PlacesServiceStatus.OK) return;
        if (results.length === 0) return;
        var firstResultPlaceId = results[0].place_id;
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'placeId': firstResultPlaceId
        }, callback);
      });
    },
    reverseGeocodeLatLng: function reverseGeocodeLatLng(location) {
      if (typeof location != "undefined" && location != null) {
        var googleMapPos = {
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lng)
        };
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'location': googleMapPos
        }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK && results[1]) {
            var place = results[1];
            $(dometic.dealerLocator2.search.autocomplete.constants.searchTextBoxIDSelector).val(place.formatted_address);
            dometic.dealerLocator2.search.doSearch();
          } else {
            location.lat = "";
            location.lng = "";
          }
        });
      } else {
        //todo handle location == null
      }
      ;
    },
    init: function init() {
      this.setupGoogleAutoComplete();
      this.bindEvents();
    }
  },
  useMyLocation: {
    bindEvents: function bindEvents() {
      this.bindGetMyPosition();
    },
    getMyPositionOnPageLoad: function getMyPositionOnPageLoad() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(dometic.dealerLocator2.search.useMyLocation.onGeoLocationSuccess, dometic.dealerLocator2.search.useMyLocation.onGeoLocationError);
      }
    },
    onGeoLocationSuccess: function onGeoLocationSuccess(position) {
      dometic.dealerLocator2.search.useMyLocation.getLatLongFromUserPosition({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }, dometic.dealerLocator2.search.useMyLocation.onLatLongFromUserPositionSuccess, dometic.dealerLocator2.search.useMyLocation.onLatLongFromUserPositionError);
    },
    onGeoLocationError: function onGeoLocationError() {},
    getLatLongFromUserPosition: function getLatLongFromUserPosition(latLng, callbackSuccess, callbackError) {
      if (latLng !== null) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'location': latLng
        }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
              callbackSuccess(results[1]);
            } else {
              callbackError();
            }
          } else {
            callbackError();
          }
        });
      } else {
        callbackError();
      }
      ;
    },
    onLatLongFromUserPositionSuccess: function onLatLongFromUserPositionSuccess(place) {
      dometic.dealerLocator2.search.context.location.lat = place.geometry.location.lat();
      dometic.dealerLocator2.search.context.location.lng = place.geometry.location.lng();
      $(dometic.dealerLocator2.search.autocomplete.constants.searchTextBoxIDSelector).val(place.formatted_address);
    },
    onLatLongFromUserPositionError: function onLatLongFromUserPositionError() {
      //todo show user that we couldnt find the position
    }
  },
  filters: {
    constants: {
      partnerTypeRadioButtonNameSelector: "input[type=radio][name=partnerType]",
      partnerTypeDefaultValueSelector: "input[type=radio][name=partnerType]:checked",
      otherFiltersIDSelector: "#other-filters",
      otherFiltersCheckboxesSelector: "#other-filters input",
      productCategoryFiltersIDSelector: "#productCategory-filters",
      productCategoryCheckboxesSelector: "#productCategory-dropdown option",
      productCategoryDropdownSelector: "#productCategory-dropdown",
      productTypeDropdownSelector: "#productType-dropdown",
      productTypeFiltersIDSelector: "#productType-filters",
      filterTypesDataAttribute: "filter-type",
      otherFiltersIDs: {
        onroad: "onroad",
        stationary: "stationary"
      },
      filterTypes: {
        productCategory: "productCategory",
        productType: "productType"
      },
      partnerTypes: {
        dealer: "dealer",
        serviceCenter: "serviceCenter"
      }
    },
    bindEvents: function bindEvents() {
      $(this.constants.partnerTypeRadioButtonNameSelector).on("change", this.onPartnerTypeChanged);
      $(this.constants.otherFiltersCheckboxesSelector).on("change", this.onFilterCheckboxChanged);
      $(this.constants.productCategoryDropdownSelector).on("change", this.onSingleFilterDropDownChanged);
      $(this.constants.productTypeDropdownSelector).on("change", this.onSingleFilterDropDownChanged);
    },
    setSelectedPartnerType: function setSelectedPartnerType(partnerTypeValue) {
      $(this.constants.partnerTypeRadioButtonNameSelector).val(partnerTypeValue).change();
    },
    onPartnerTypeChanged: function onPartnerTypeChanged() {
      dometic.dealerLocator2.search.redoSearchButton.showRedoSearchButton();
      var value = $(this).val();
      if (value === dometic.dealerLocator2.search.filters.constants.partnerTypes.dealer) {
        $(dometic.dealerLocator2.search.filters.constants.otherFiltersIDSelector).hide();
        dometic.dealerLocator2.search.context.stationary = null;
        dometic.dealerLocator2.search.context.onroad = null;
        dometic.dealerLocator2.search.filters.setSelectedFiltersInDropDown(["0"], $(dometic.dealerLocator2.search.filters.constants.productCategoryDropdownSelector));
        $(dometic.dealerLocator2.search.filters.constants.productCategoryDropdownSelector).selectpicker('refresh');
        $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector).hide();
      } else if (value === dometic.dealerLocator2.search.filters.constants.partnerTypes.serviceCenter) {
        dometic.dealerLocator2.search.filters.setSelectedFiltersInDropDown(["0"], $(dometic.dealerLocator2.search.filters.constants.productCategoryDropdownSelector));
        $(dometic.dealerLocator2.search.filters.constants.productCategoryDropdownSelector).selectpicker('refresh');
        $(dometic.dealerLocator2.search.filters.constants.otherFiltersIDSelector).show();
      }

      //Reset the product type array in case it is populated when we switch between partner type
      if (dometic.dealerLocator2.search.context.productType.length > 0) {
        dometic.dealerLocator2.search.context.productType = [];
      }
      //Reset the product category array in case it is populated when we switch between partner type
      if (dometic.dealerLocator2.search.context.productCategories.length > 0) {
        dometic.dealerLocator2.search.context.productCategories = [];
      }
      $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector).hide();
      dometic.dealerLocator2.search.context.partnerType = value;
    },
    setSelectedFiltersInDropDown: function setSelectedFiltersInDropDown(filterValues, dropdown) {
      for (var i = 0; i < filterValues.length; i++) {
        var filterValue = filterValues[i];
        dropdown.find("option[value='" + filterValue + "']").prop('selected', true);
      }
    },
    onSingleFilterDropDownChanged: function onSingleFilterDropDownChanged(event) {
      var isQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      dometic.dealerLocator2.search.redoSearchButton.showRedoSearchButton();
      var $currentOption = $(this);

      //$currentOption[0][1] represents the first selectable option. This is only to get the filter type.
      var filterType = $($currentOption[0][1]).data(dometic.dealerLocator2.search.filters.constants.filterTypesDataAttribute);
      var arrayToAlter = [];
      if (filterType === dometic.dealerLocator2.search.filters.constants.filterTypes.productCategory) {
        if ($currentOption.val() === "0") {
          dometic.dealerLocator2.search.context.productCategories = [];
        }
        //reset the product type list if we change the product category TODO: Reset the dropdown?
        if (!isQuery) {
          dometic.dealerLocator2.search.context.productType = [];
        }
        arrayToAlter = dometic.dealerLocator2.search.context.productCategories;
      }
      if (filterType === dometic.dealerLocator2.search.filters.constants.filterTypes.productType) {
        arrayToAlter = dometic.dealerLocator2.search.context.productType;
      }
      if (arrayToAlter.length > 0) {
        if (!isQuery) {
          var restedArray = dometic.dealerLocator2.search.filters.resetFilterForSpecificArray(arrayToAlter);
          dometic.dealerLocator2.search.filters.removeFilter($currentOption, arrayToAlter);
          dometic.dealerLocator2.search.filters.addFilter($currentOption, restedArray);
        } else {
          dometic.dealerLocator2.search.filters.addFilter($currentOption, arrayToAlter);
        }
      } else {
        dometic.dealerLocator2.search.filters.addFilter($currentOption, arrayToAlter);
      }
      if (filterType === dometic.dealerLocator2.search.filters.constants.filterTypes.productCategory) {
        var data = {
          scAction: "GetProductTypesBySelectedProductCategory",
          scController: "DealerLocator2",
          productCategoryPimId: dometic.dealerLocator2.search.context.productCategories[0],
          contextItem: $("body").data("sc-item"),
          contextLanguage: $("body").data("sc-language")
        };
        $.ajax({
          method: "GET",
          url: "/get-producttypes",
          data: data
        }).done(function (result) {
          var productTypeDropdown = $(dometic.dealerLocator2.search.filters.constants.productTypeDropdownSelector);
          if (result.length > 0) {
            var nothingSelectedOption = $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector + ' .nothing-selected').detach();
            console.log(nothingSelectedOption);
            productTypeDropdown.empty().append(nothingSelectedOption);
            $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector).removeClass("hidden");
            $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector).show();
            for (var i = 0; i < result.length; i++) {
              productTypeDropdown.append("<option class=\"dealerLocatorFilterComponent-productCategoryFilter\" data-filter-type=\"productType\" value=\"".concat(result[i].Value, "\">").concat(result[i].Key, "</option>"));
            }
            if (!isQuery) {
              $(productTypeDropdown).trigger("change");
            } else {
              $(productTypeDropdown).trigger("change", [true]);
              dometic.dealerLocator2.search.filters.setSelectedFiltersInDropDown(dometic.dealerLocator2.search.context.productType, productTypeDropdown);
            }
            $(productTypeDropdown).selectpicker('refresh');
          } else {
            var nothingSelectedOption = $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector + ' .nothing-selected').detach();
            productTypeDropdown.empty().append(nothingSelectedOption);
            $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector).addClass("hidden");
            $(productTypeDropdown).selectpicker('refresh');
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          $(dometic.dealerLocator2.search.filters.constants.productTypeFiltersIDSelector).addClass("hidden");
          $(productTypeDropdown).selectpicker('refresh');
        });
      }
    },
    onFilterCheckboxChanged: function onFilterCheckboxChanged() {
      dometic.dealerLocator2.search.redoSearchButton.showRedoSearchButton();
      var $currentInput = $(this);
      var id = $currentInput.attr('id');
      if (id === dometic.dealerLocator2.search.filters.constants.otherFiltersIDs.onroad) {
        dometic.dealerLocator2.search.context.onroad = $currentInput.is(":checked");
      } else if (id === dometic.dealerLocator2.search.filters.constants.otherFiltersIDs.stationary) {
        dometic.dealerLocator2.search.context.stationary = $currentInput.is(":checked");
      }
    },
    resetFilterForSpecificArray: function resetFilterForSpecificArray(arrayToReset) {
      if (arrayToReset === dometic.dealerLocator2.search.context.productCategories) {
        return dometic.dealerLocator2.search.context.productCategories = [];
      }
      if (arrayToReset === dometic.dealerLocator2.search.context.productType) {
        return dometic.dealerLocator2.search.context.productType = [];
      }
    },
    addFilter: function addFilter($currentInput, filterArrayToAddTo) {
      var indexInArray = filterArrayToAddTo.indexOf($currentInput.val());
      if (indexInArray > -1) return;
      if ($currentInput.val() === "0") return;
      filterArrayToAddTo.push($currentInput.val());
    },
    removeFilter: function removeFilter($currentOption, filterArrayToRemoveFrom) {
      var indexInArray = filterArrayToRemoveFrom.indexOf($currentOption.val());
      if (indexInArray === -1) return;
      filterArrayToRemoveFrom.splice(indexInArray, 1);
    },
    init: function init() {
      this.bindEvents();
      dometic.dealerLocator2.search.context.partnerType = $(this.constants.partnerTypeDefaultValueSelector).val();
      if (dometic.dealerLocator2.search.context.partnerType === dometic.dealerLocator2.search.filters.constants.partnerTypes.dealer) {
        $(dometic.dealerLocator2.search.filters.constants.otherFiltersIDSelector).hide();
      } else if (dometic.dealerLocator2.search.context.partnerType === dometic.dealerLocator2.search.filters.constants.partnerTypes.serviceCenter) {
        $(dometic.dealerLocator2.search.filters.constants.otherFiltersIDSelector).show();
      }
    }
  },
  handleFilterContextInQueryString: function handleFilterContextInQueryString() {
    var splittedquerystring = window.location.search.split("?");
    if (splittedquerystring.length === 1) return;
    var querystring = splittedquerystring[1];
    var params = $.deparam(querystring);
    if (typeof params.partnerType !== "undefined") {
      this.filters.setSelectedPartnerType(params.partnerType);
    }
    if (typeof params.productCategories !== "undefined") {
      this.filters.setSelectedFiltersInDropDown(params.productCategories, $(this.filters.constants.productCategoryDropdownSelector));
      this.context.productCategories = params.productCategories;
      $(this.filters.constants.productCategoryDropdownSelector).trigger("change", [true]);
    }
    if (typeof params.productType !== "undefined") {
      this.filters.setSelectedFiltersInDropDown(params.productType, $(this.filters.constants.productTypeDropdownSelector));
      this.context.productType = params.productType;
    }
    if (typeof params.onroad !== "undefined") {
      $("#" + this.filters.constants.otherFiltersIDs.onroad).prop("checked", params.onroad === "true");
      this.context.onroad = params.onroad === "true";
    }
    if (typeof params.stationary !== "undefined") {
      $("#" + this.filters.constants.otherFiltersIDs.stationary).prop("checked", params.stationary === "true");
      this.context.stationary = params.stationary === "true";
    }
    if (typeof params.distance !== "undefined") {
      this.context.distance = params.distance;
    }
    if (typeof params.groups !== "undefined") {
      this.context.groups = params.groups;
    }
    if (typeof params.debug !== "undefined") {
      this.context.debug = params.debug;
    }
    if (typeof params.maxResults !== "undefined") {
      this.context.maxResults = params.maxResults;
    }
    if (typeof params.location !== "undefined" && typeof params.location.lat !== "undefined" && typeof params.location.lng !== "undefined") {
      this.context.location.lat = params.location.lat;
      this.context.location.lng = params.location.lng;
      this.autocomplete.reverseGeocodeLatLng(this.context.location);
    } else if (typeof params.zip !== "undefined") {
      var zipCode = params.zip;
      var country = params.country;
      this.handleZipCodeInQueryString(zipCode, country, function (zipLocation) {
        if (zipLocation) {
          dometic.dealerLocator2.search.context.location.lat = location.lat;
          dometic.dealerLocator2.search.context.location.lng = location.lng;
          dometic.dealerLocator2.search.autocomplete.reverseGeocodeLatLng(location);
        }
      });
    }
  },
  handleZipCodeInQueryString: function handleZipCodeInQueryString(zip, country, callback) {
    var addressParameter = zip;
    if (typeof country !== "undefined" && country != null) {
      addressParameter = addressParameter + "," + country;
    } else {
      addressParameter = addressParameter + "," + $("body").data("sc-market");
    }
    var url = "http://maps.googleapis.com/maps/api/geocode/json?address=" + addressParameter;
    $.get(url, function (data) {
      if (data.status !== "OK") {
        callback("ZERO_RESULTS");
      } else {
        dometic.dealerLocator2.search.context.location.lat = data.results[0].geometry.location.lat;
        dometic.dealerLocator2.search.context.location.lng = data.results[0].geometry.location.lng;
        dometic.dealerLocator2.search.autocomplete.reverseGeocodeLatLng(data.results[0].geometry.location);
      }
    });
  },
  redoSearchButton: {
    constants: {
      redoSearchButtonIDSelector: "#dealerLocatorMapComponent-btnRedoSearch"
    },
    bindEvents: function bindEvents() {
      $(this.constants.redoSearchButtonIDSelector).click(this.redoSearchInThisAreaClicked);
    },
    redoSearchInThisAreaClicked: function redoSearchInThisAreaClicked() {
      if (typeof dometic.dealerLocator2.mapView != 'undefined') {
        dometic.dealerLocator2.mapView.getMapInformation();
        dometic.dealerLocator2.mapView.current.zoom = dometic.dealerLocator2.mapView.current.mapInformation.zoom;

        //var searchDistance = 5000;
        //var mapViewPortDistance = dometic.dealerLocator2.mapView.getMapViewportDistance();
        //if (mapViewPortDistance != null) {
        //    searchDistance = mapViewPortDistance;
        //} 

        dometic.dealerLocator2.search.context.location.lat = dometic.dealerLocator2.mapView.current.mapInformation.lat;
        dometic.dealerLocator2.search.context.location.lng = dometic.dealerLocator2.mapView.current.mapInformation.lng;
        dometic.dealerLocator2.search.context.distance = dometic.dealerLocator2.search.constants.startDistance;
        dometic.dealerLocator2.search.context.maxResults = dometic.dealerLocator2.search.constants.startMaxResults;
        dometic.dealerLocator2.search.autocomplete.reverseGeocodeLatLng(dometic.dealerLocator2.search.context.location);
      }
    },
    showRedoSearchButton: function showRedoSearchButton() {
      $(this.constants.redoSearchButtonIDSelector).removeClass("hidden");
    },
    hideRedoSearchButton: function hideRedoSearchButton() {
      $(this.constants.redoSearchButtonIDSelector).addClass("hidden");
    },
    addLoadingClass: function addLoadingClass() {
      $(dometic.dealerLocator2.search.redoSearchButton.constants.redoSearchButtonIDSelector).addClass("is-loading");
    },
    removeLoadingClass: function removeLoadingClass() {
      $(dometic.dealerLocator2.search.redoSearchButton.constants.redoSearchButtonIDSelector).removeClass("is-loading");
    }
  },
  doSearch: function doSearch(withScrollAnimation) {
    dometic.dealerLocator2.search.searchButton.addLoadingClass();
    dometic.dealerLocator2.search.redoSearchButton.addLoadingClass();
    var location = this.context.location;
    var querystring = this.createSearchQueryString(this.context);
    var queryStringWithDealerContext = this.addDealerContextToQuerystring(querystring);
    $.ajax({
      url: "/get-dealerlocator2-search?" + queryStringWithDealerContext,
      dataType: "json",
      success: function success(result) {
        dometic.dealerLocator2.search.searchButton.removeLoadingClass();
        dometic.dealerLocator2.search.redoSearchButton.removeLoadingClass();
        var url = window.location.href.split("?")[0];
        history.pushState({}, document.title, url + "?" + decodeURIComponent(querystring));
        var resultsNeededForMapDisplay = 3;
        if (dometic.dealerLocator2.search.context.distance >= 5000) resultsNeededForMapDisplay = 0;
        if (result.Partners.length > resultsNeededForMapDisplay) {
          $(".dealerLocatorHeroComponent-header").slideUp(200, function () {
            var doScroll = typeof withScrollAnimation !== 'undefined' ? withScrollAnimation : true;
            if (doScroll) {
              //scroll to result div
              $('html, body').animate({
                scrollTop: $("#scrollToThisWhenSearchIsFinished").offset().top - $("header.Header").height()
              }, 500);
            }
          });
          $("#dealerLocatorNoResults").slideUp(200, function () {
            $("#dealerLocatorMapComponent").slideDown(500, function () {
              dometic.dealerLocator2.listView.populateData(result);
              if (typeof dometic.dealerLocator2.mapView != 'undefined') {
                dometic.dealerLocator2.mapView.populateData(result.Partners, location);
                if (dometic.dealerLocator2.search.context.debug) {
                  dometic.dealerLocator2.mapView.circle(dometic.dealerLocator2.search.context);
                  dometic.dealerLocator2.mapView.rectangle(dometic.dealerLocator2.search.context);
                }
              }
            });
          });
        } else {
          dometic.dealerLocator2.search.doExpandedSearch();
        }
      },
      error: function error(data) {
        console.log(data);
      }
    });
  },
  doExpandedSearch: function doExpandedSearch() {
    if (this.context.distance < 60) {
      this.context.distance = 60;
      dometic.dealerLocator2.search.doSearch();
    } else if (this.context.distance < 120) {
      this.context.distance = 120;
      dometic.dealerLocator2.search.doSearch();
    } else if (this.context.distance < 250) {
      this.context.distance = 250;
      dometic.dealerLocator2.search.doSearch();
    } else if (this.context.distance < 500) {
      this.context.distance = 500;
      dometic.dealerLocator2.search.doSearch();
    } else if (this.context.distance < 1000) {
      this.context.distance = 1000;
      dometic.dealerLocator2.search.doSearch();
    } else if (this.context.distance < 2500) {
      this.context.distance = 2500;
      dometic.dealerLocator2.search.doSearch();
    } else if (this.context.distance < 5000) {
      this.context.distance = 5000;
      dometic.dealerLocator2.search.doSearch();
    } else {
      $("#dealerLocatorMapComponent").slideUp(200, function () {
        $("#dealerLocatorNoResults").slideDown(500);
      });
    }
  },
  createSearchQueryString: function createSearchQueryString(searchContext) {
    if (typeof searchContext.groups !== 'undefined') {
      if (searchContext.groups.length <= 0 || searchContext.groups == null || searchContext.groups[0] === "") {
        delete searchContext.groups;
      }
    }
    var result = $.param(searchContext);
    return result;
  },
  addDealerContextToQuerystring: function addDealerContextToQuerystring(querystring) {
    var dealerLocatorRenderingDatasource = $(".dealerLocatorHeroComponent").data("dealer-item");
    var sitecoreContextItem = $("body").data("sc-item");
    var sitecoreContextLanguage = $("body").data("sc-language");
    return querystring + "&sitecoreItemId=" + sitecoreContextItem + "&sitecoreLanguageId=" + sitecoreContextLanguage + "&dealerItemId=" + dealerLocatorRenderingDatasource;
  },
  handleInitialMapSettings: function handleInitialMapSettings() {
    var initialLat = $("#dealerLocatorMapComponent").data("initial-lat");
    var initialLng = $("#dealerLocatorMapComponent").data("initial-lng");
    if (typeof initialLat !== 'undefined' && typeof initialLng != 'undefined') {
      this.context.location.lat = initialLat;
      this.context.location.lng = initialLng;
      this.context.distance = 10000;
      dometic.dealerLocator2.search.doSearch(false);
    }
  }
};
(function ($) {
  dometic.dealerLocator2.search.init();
})(jQuery);